import React from "react";

const Contact = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-extrabold text-gray-900">Contact Us</h1>

      <p className="mt-4 text-gray-700">
        Have any questions or feedback? We'd love to hear from you! Reach out to
        us via email, and our team will get back to you as soon as possible.
      </p>

      <div className="mt-6 p-4 border border-gray-300 rounded-md bg-gray-50">
        <p className="text-lg font-semibold text-gray-800">Email Support:</p>
        <p className="text-blue-600 font-medium">support@minilo.blog</p>
      </div>

      <h2 className="mt-6 text-2xl font-semibold text-gray-800">
        Stay Connected
      </h2>
      <p className="mt-3 text-gray-700">
        Follow us for updates, new articles, and Minilo AI insights.
      </p>
    </div>
  );
};

export default Contact;
